import { forwardRef, type Ref, type SVGProps } from "react";
const IconArrowDownOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M24.69 17.19a1 1 0 0 0-1.48 0L17 23.5V6a1 1 0 1 0-2 0v17.5l-6.21-6.31a1 1 0 0 0-1.48 0 1.07 1.07 0 0 0 0 1.5l7.89 8a1.1 1.1 0 0 0 .8.31 1.13 1.13 0 0 0 .8-.31l7.89-8a1.07 1.07 0 0 0 0-1.5" />
  </svg>
);
const ForwardRef = forwardRef(IconArrowDownOutlineSVG);
ForwardRef.displayName = "IconArrowDownOutline";
export { ForwardRef as IconArrowDownOutline };
